// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as CommonUtils$OrcaPaymentPage from "./CommonUtils.bs.js";
import * as SuperpositionTypes$OrcaPaymentPage from "../types/SuperpositionTypes.bs.js";

var billingAddressPathPrefix = "payment_method_data.billing.address.";

var billingAddressLine2Path = billingAddressPathPrefix + "line2";

function isBillingAddressPath(path) {
  return path.startsWith(billingAddressPathPrefix);
}

function isBillingAddressLine2(path) {
  return path === billingAddressLine2Path;
}

function resolveFieldInclusion(confirmRequestWritePath, connectorRequired, isUseBillingAddress) {
  var forcedBilling = isUseBillingAddress && confirmRequestWritePath.startsWith(billingAddressPathPrefix);
  var shouldInclude = connectorRequired || forcedBilling;
  var isRequired = connectorRequired || forcedBilling && confirmRequestWritePath !== billingAddressLine2Path;
  return [
          shouldInclude,
          isRequired
        ];
}

function sortFieldsByPriorityOrder(fields) {
  fields.sort(function (a, b) {
        return Caml.int_compare(a.fieldDisplayOrder, b.fieldDisplayOrder);
      });
  return fields;
}

function removeDuplicateConnectors(fields) {
  var seen = new Set();
  return fields.filter(function (f) {
              if (seen.has(f)) {
                return false;
              } else {
                seen.add(f);
                return true;
              }
            });
}

function removeDuplicateFields(fields) {
  var seen = new Set();
  return fields.filter(function (f) {
              if (seen.has(f.confirmRequestWritePath)) {
                return false;
              } else {
                seen.add(f.confirmRequestWritePath);
                return true;
              }
            });
}

function extractFieldValuesFromPML(required_fields) {
  var flatInitialValues = {};
  Object.entries(required_fields).forEach(function (param) {
        var requiredFieldDict = CommonUtils$OrcaPaymentPage.getDictFromJson(param[1]);
        var match = requiredFieldDict["required_field"];
        var match$1 = requiredFieldDict["value"];
        if (match === undefined) {
          return ;
        }
        if (match$1 === undefined) {
          return ;
        }
        var field = CommonUtils$OrcaPaymentPage.getStringFromJson(match, "");
        var value = CommonUtils$OrcaPaymentPage.getStringFromJson(match$1, "");
        if (field !== "") {
          flatInitialValues[field] = value;
          return ;
        }
        
      });
  return flatInitialValues;
}

function resolveFieldValue(field, intentDataDict, suppressBillingPrefillOpt) {
  var suppressBillingPrefill = suppressBillingPrefillOpt !== undefined ? suppressBillingPrefillOpt : false;
  if (suppressBillingPrefill && field.confirmRequestWritePath.startsWith(billingAddressPathPrefix)) {
    return ;
  }
  var readPath = field.intentDataReadPath;
  if (readPath === undefined) {
    return ;
  }
  var val = CommonUtils$OrcaPaymentPage.getStringAtPath(intentDataDict, readPath);
  if (val !== undefined && val !== "") {
    return val;
  }
  
}

function filterFieldsBasedOnMissingData(requiredFieldsFromSuperPosition, intentDataDict, isUseBillingAddressOpt) {
  var isUseBillingAddress = isUseBillingAddressOpt !== undefined ? isUseBillingAddressOpt : false;
  var isFieldMissing = function (field) {
    return Core__Option.isNone(resolveFieldValue(field, intentDataDict, undefined));
  };
  var match = Core__Array.reduce(requiredFieldsFromSuperPosition, [
        [],
        false,
        false,
        false
      ], (function (param, field) {
          var acc = param[0];
          var path = field.confirmRequestWritePath;
          var fieldMissing = isFieldMissing(field);
          var isNameField = path.includes("billing.address.first_name") || path.includes("billing.address.last_name");
          var isPhoneField = path.includes("billing.phone");
          var isAddressField = path.includes("billing.address.") && !isNameField;
          var fieldCategory = [
            field,
            isNameField,
            isPhoneField,
            isAddressField
          ];
          var newNameMissing = param[1] || isNameField && fieldMissing;
          var newPhoneMissing = param[2] || isPhoneField && fieldMissing;
          var newAddressMissing = param[3] || isAddressField && fieldMissing;
          acc.push(fieldCategory);
          return [
                  acc,
                  newNameMissing,
                  newPhoneMissing,
                  newAddressMissing
                ];
        }));
  var addressFieldsMissing = match[3];
  var phoneFieldsMissing = match[2];
  var nameFieldsMissing = match[1];
  return Core__Array.filterMap(match[0], (function (param) {
                var isAddressField = param[3];
                var isPhoneField = param[2];
                var isNameField = param[1];
                var field = param[0];
                var forceBillingAddress = isUseBillingAddress && (isNameField || isAddressField);
                var shouldInclude = forceBillingAddress || isNameField && nameFieldsMissing || isPhoneField && phoneFieldsMissing || isAddressField && addressFieldsMissing || !isNameField && !isPhoneField && !isAddressField && isFieldMissing(field);
                if (shouldInclude) {
                  return field;
                }
                
              }));
}

function buildInitialValuesFromIntentData(fields, intentDataDict, suppressBillingPrefillOpt) {
  var suppressBillingPrefill = suppressBillingPrefillOpt !== undefined ? suppressBillingPrefillOpt : false;
  return Core__Array.reduce(fields, {}, (function (acc, field) {
                var val = resolveFieldValue(field, intentDataDict, suppressBillingPrefill);
                if (val !== undefined) {
                  acc[field.confirmRequestWritePath] = val;
                }
                return acc;
              }));
}

function getOrCreateNestedDictionary(dict, key) {
  var json = dict[key];
  if (json !== undefined) {
    return CommonUtils$OrcaPaymentPage.getDictFromJson(json);
  } else {
    return {};
  }
}

function setValueAtNestedPath(dict, keys, value) {
  var keysLength = keys.length;
  if (keysLength === 0) {
    return dict;
  }
  if (keysLength === 1) {
    var key = CommonUtils$OrcaPaymentPage.getArrayElement(keys, 0, "");
    if (key !== "" && value !== "") {
      dict[key] = value;
    }
    return dict;
  }
  var currentDict = dict;
  var pathLength = keysLength - 1 | 0;
  for(var i = 0; i < pathLength; ++i){
    var key$1 = CommonUtils$OrcaPaymentPage.getArrayElement(keys, i, "");
    if (key$1 !== "") {
      var nestedDict = getOrCreateNestedDictionary(currentDict, key$1);
      currentDict[key$1] = nestedDict;
      currentDict = nestedDict;
    }
    
  }
  var finalKey = CommonUtils$OrcaPaymentPage.getArrayElement(keys, pathLength, "");
  if (finalKey !== "" && value !== "") {
    currentDict[finalKey] = value;
  }
  return dict;
}

function removeEmptyObjects(dict) {
  var cleanedDict = {};
  Object.entries(dict).forEach(function (param) {
        var value = param[1];
        var key = param[0];
        var nestedDict = Core__JSON.Classify.classify(value);
        if (typeof nestedDict !== "object") {
          cleanedDict[key] = value;
          return ;
        }
        if (nestedDict.TAG === "Object") {
          var cleaned = removeEmptyObjects(nestedDict._0);
          if (Object.entries(cleaned).length > 0) {
            cleanedDict[key] = cleaned;
            return ;
          } else {
            return ;
          }
        }
        cleanedDict[key] = value;
      });
  return cleanedDict;
}

function convertFlatDictToNestedObject(flatDict) {
  var resultDict = {};
  Object.entries(flatDict).forEach(function (param) {
        var key = param[0];
        if (key.length > 0) {
          setValueAtNestedPath(resultDict, key.split("."), param[1]);
          return ;
        }
        
      });
  return removeEmptyObjects(resultDict);
}

function convertConfigurationToRequiredFields(resolvedConfig, isUseBillingAddressOpt) {
  var isUseBillingAddress = isUseBillingAddressOpt !== undefined ? isUseBillingAddressOpt : false;
  var fieldGroups = {};
  Object.entries(resolvedConfig).forEach(function (param) {
        var parts = param[0].split("._");
        var match = parts[0];
        var match$1 = parts[1];
        if (match === undefined) {
          return ;
        }
        if (match$1 === undefined) {
          return ;
        }
        if (!(match !== "" && match$1 !== "")) {
          return ;
        }
        var group = fieldGroups[match];
        var fieldGroup;
        if (group !== undefined) {
          fieldGroup = group;
        } else {
          var newGroup = {};
          fieldGroups[match] = newGroup;
          fieldGroup = newGroup;
        }
        fieldGroup[match$1] = param[1];
      });
  return Core__Array.filterMap(Object.entries(fieldGroups), (function (param) {
                var metadata = param[1];
                var baseName = param[0];
                var connectorRequired = CommonUtils$OrcaPaymentPage.getBool(metadata, "is_required", false);
                var confirmRequestWritePath = CommonUtils$OrcaPaymentPage.getString(metadata, "confirm_request_write_path", baseName);
                var match = resolveFieldInclusion(confirmRequestWritePath, connectorRequired, isUseBillingAddress);
                if (!match[0]) {
                  return ;
                }
                var defaultLabelText = CommonUtils$OrcaPaymentPage.getString(metadata, "default_label_text", baseName);
                var defaultPlaceholderText = CommonUtils$OrcaPaymentPage.getString(metadata, "default_placeholder_text", "");
                var fieldRenderTypeStr = CommonUtils$OrcaPaymentPage.getString(metadata, "field_render_type", "");
                var fieldDisplayOrder = CommonUtils$OrcaPaymentPage.getInt(metadata, "field_display_order", 1000);
                var dropdownOptions = Core__Option.map(CommonUtils$OrcaPaymentPage.getOptionalArrayFromDict(metadata, "dropdown_options"), (function (arr) {
                        return Core__Array.filterMap(arr, Core__JSON.Decode.string);
                      }));
                var intentDataReadPath = CommonUtils$OrcaPaymentPage.getOptionString(metadata, "intent_data_read_path");
                var renderWhenPrefilled = CommonUtils$OrcaPaymentPage.getOptionBool(metadata, "render_when_prefilled");
                var validationRuleType = CommonUtils$OrcaPaymentPage.getOptionString(metadata, "validation_rule_type");
                var validationRegexPattern = CommonUtils$OrcaPaymentPage.getOptionString(metadata, "validation_regex_pattern");
                var labelLocalizationKey = CommonUtils$OrcaPaymentPage.getOptionString(metadata, "label_localization_key");
                var placeholderLocalizationKey = CommonUtils$OrcaPaymentPage.getOptionString(metadata, "placeholder_localization_key");
                var inputFormatPattern = CommonUtils$OrcaPaymentPage.getOptionString(metadata, "input_format_pattern");
                var htmlAutocompleteAttribute = CommonUtils$OrcaPaymentPage.getOptionString(metadata, "html_autocomplete_attribute");
                var keyboardType = CommonUtils$OrcaPaymentPage.getOptionString(metadata, "keyboard_type");
                var maxInputLength = CommonUtils$OrcaPaymentPage.getOptionInt(metadata, "max_input_length");
                var layoutRowId = CommonUtils$OrcaPaymentPage.getOptionString(metadata, "layout_row_id");
                var layoutWidthRatio = CommonUtils$OrcaPaymentPage.getOptionFloat(metadata, "layout_width_ratio");
                var merchantProvidedDisplayName = CommonUtils$OrcaPaymentPage.getOptionString(metadata, "merchant_provided_display_name");
                var merchantProvidedPlaceholderText = CommonUtils$OrcaPaymentPage.getOptionString(metadata, "merchant_provided_placeholder_text");
                return {
                        intentDataReadPath: intentDataReadPath,
                        defaultLabelText: defaultLabelText,
                        defaultPlaceholderText: defaultPlaceholderText,
                        fieldRenderType: SuperpositionTypes$OrcaPaymentPage.stringToFieldType(fieldRenderTypeStr),
                        fieldDisplayOrder: fieldDisplayOrder,
                        isRequired: match[1],
                        dropdownOptions: dropdownOptions,
                        confirmRequestWritePath: confirmRequestWritePath,
                        renderWhenPrefilled: renderWhenPrefilled,
                        validationRuleType: validationRuleType,
                        validationRegexPattern: validationRegexPattern,
                        labelLocalizationKey: labelLocalizationKey,
                        placeholderLocalizationKey: placeholderLocalizationKey,
                        inputFormatPattern: inputFormatPattern,
                        htmlAutocompleteAttribute: htmlAutocompleteAttribute,
                        keyboardType: keyboardType,
                        maxInputLength: maxInputLength,
                        layoutRowId: layoutRowId,
                        layoutWidthRatio: layoutWidthRatio,
                        merchantProvidedDisplayName: merchantProvidedDisplayName,
                        merchantProvidedPlaceholderText: merchantProvidedPlaceholderText
                      };
              }));
}

export {
  billingAddressPathPrefix ,
  billingAddressLine2Path ,
  isBillingAddressPath ,
  isBillingAddressLine2 ,
  resolveFieldInclusion ,
  sortFieldsByPriorityOrder ,
  removeDuplicateConnectors ,
  removeDuplicateFields ,
  extractFieldValuesFromPML ,
  resolveFieldValue ,
  filterFieldsBasedOnMissingData ,
  buildInitialValuesFromIntentData ,
  getOrCreateNestedDictionary ,
  setValueAtNestedPath ,
  removeEmptyObjects ,
  convertFlatDictToNestedObject ,
  convertConfigurationToRequiredFields ,
}
/* No side effect */
